{
  "password-form": {
    "text": {
      "password": "Mật khẩu",
      "password-confirmation": "Xác nhận mật khẩu"
    }
  }
}
